/**
 * Rebuy: Disable increase quantity button if quantity exceeds available inventory at Simmons Building
 */
document.addEventListener('rebuy:cart.change', (event) => {
  // Fix for Rebuy where the 'product' property isn't immediately available
  setTimeout(() => {
    validateLineItemQuantities(event);
    hideQuantityIncreaseForRestrictedItems(event);
    enforceMinOrderQuantities(event);
  }, 0);
});


function validateLineItemQuantities(event) {
  const cartItems         = event.detail.cart.cart.items;
  const simmonsLocationId = '25491026';

  // Ensure DOM updates are complete before running logic
  const cartElement = event.target.querySelector('[data-smartcart-items]');

  if (!cartElement || !cartItems || cartItems.length === 0) return;

  const lineItemElements = cartElement.querySelectorAll('.rebuy-cart__flyout-item');

  // if the inventory levels are valid, return
  cartItems.forEach((item, index) => {
    const inventoryLevels = item?.product?.selected_variant?.metafields?.custom?.inventory_levels;

    if (!inventoryLevels || typeof inventoryLevels !== 'object' || inventoryLevels === null) {
      console.warn('No inventory levels found for item:', item);
      return;
    }

    // Find inventory level for Simmons Building
    const simmonsLocation = inventoryLevels.find((level) => level.location.id.includes(simmonsLocationId));
    if (!simmonsLocation) return;

    const { available, tracked } = simmonsLocation;

    if (tracked !== true) return;

    // Get the "Increase Quantity" button for the current line item
    const increaseQtyButton = lineItemElements[index]?.querySelector('.rebuy-cart__flyout-item-quantity-widget-button--increase');

    if (!increaseQtyButton) {
      console.warn('Increase quantity button not found for item:', item);
      return;
    }

    // Update item quantity based on available inventory
    if (tracked) {
      if (item.quantity === available) {
        showMessage();

      } else if (item.quantity >= available) {
        console.warn(`item.quantity: ${JSON.stringify(item.quantity)}`);
        Rebuy.Cart.setItemQuantity(item, available, showMessage);

      } else if (item.quantity < available) {
        removeMessage();
      }
    }

    // Disable the increase quantity button if item quantity exceeds availability
    increaseQtyButton.disabled = item.quantity >= available;

    // Function to show a message if the quantity exceeds available stock
    function showMessage() {
      const footerContainer = lineItemElements[index]?.querySelector('.rebuy-cart__flyout-item-footer-container');

      if (!footerContainer) return;

      // Check if the message already exists to prevent duplicates
      const existingMessage = footerContainer.querySelector('.rebuy-cart__flyout-item-message');

      if (existingMessage) return;

      const messageElement = document.createElement('span');

      messageElement.classList.add('rebuy-cart__flyout-item-message');
      messageElement.innerText = `Max available: ${available}`;

      footerContainer.appendChild(messageElement);
    }

    // Function to remove the message if quantity is within available stock
    function removeMessage() {
      const footerContainer = lineItemElements[index]?.querySelector('.rebuy-cart__flyout-item-footer-container');
      const existingMessage = footerContainer?.querySelector('.rebuy-cart__flyout-item-message');

      if (existingMessage) {
        footerContainer.removeChild(existingMessage);
      }
    }
  });
}


/**
*   Hide Quantity Increase for Subscriptions and any other product with a restrict-quantity—to-one tag
*   Addresses issue where customers think they are increasing the number of bags, where they instead were increasing subscriptions
*/
function hideQuantityIncreaseForRestrictedItems(event) {
  
  const cartItems         = event.detail.cart.cart.items;

  // Ensure DOM updates are complete before running logic
  const cartElement = event.target.querySelector('[data-smartcart-items]');

  if (!cartElement || !cartItems || cartItems.length === 0) return;

  const lineItemElements = cartElement.querySelectorAll('.rebuy-cart__flyout-item');

  // if the inventory levels are valid, return
  cartItems.forEach((item, index) => {

    // Get the "Increase Quantity" button for the current line item
    const increaseQtyButton = lineItemElements[index]?.querySelector('.rebuy-cart__flyout-item-quantity-widget-button--increase');

    if (!increaseQtyButton) {
      console.warn('Increase quantity button not found for item:', item);
      return;
    }

    // this tag doesn't restrict to a single product in the cart, it only prevents add in the cart
    const hasRestrictedTag = (item?.product?.tags||"").search(/disable-cart-increase/i) !== -1; 
    const isSubscriptionFromBuilder = item.selling_plan_allocation && item.properties._isFromBuilder;

    // Disable the increase quantity button if subscription and comes from the builder
    if (isSubscriptionFromBuilder || hasRestrictedTag) increaseQtyButton.disabled = true;

    // Force quantity to 1
    if (isSubscriptionFromBuilder && item.quantity > 1) {
      Rebuy.Cart.setItemQuantity(item, 1);
    }

  });

}

// this function ensure that for products which have mins, the user does not drop below the min in the cart. 
function enforceMinOrderQuantities(event) {
  const cartItems   = event.detail.cart.cart.items;
  const cartElement = event.target.querySelector('[data-smartcart-items]');
  if (!cartElement || !cartItems || cartItems.length === 0) return;

  const rows = cartElement.querySelectorAll('.rebuy-cart__flyout-item');

  cartItems.forEach((item, index) => {
    const min = parseInt(item?.properties?._min_qty) || 1;

    // If something already pushed it below min, correct it once.
    if (item.quantity < min) {
      Rebuy.Cart.setItemQuantity(item, min);
    }

    const decBtn = rows[index]?.querySelector(
      '.rebuy-cart__flyout-item-quantity-widget-button--decrease'
    );
    if (!decBtn) return;

    const disableDec = item.quantity <= min;
    decBtn.disabled = disableDec;
    decBtn.setAttribute('aria-disabled', disableDec ? 'true' : 'false');
  });
}


/* ==========================================================
   GLOBAL PRODUCT OPTION VALIDATOR
   ----------------------------------------------------------
   PURPOSE:
   - Ensures required visible option fields are completed
     before "Add to Bag" runs (even with AJAX enabled).

   DEFAULT BEHAVIOUR:
   - Every [data-custom-option-input] is treated as required
     unless explicitly marked optional.

   HOW TO OPT OUT (per field):
   - Add  data-ps-optional="true"  to skip validation.
   - Or hide the input (display:none / disabled).

   HOW TO CUSTOMIZE MESSAGE:
   - Add  data-ps-required-msg="Your custom text"  to override
     the default "This field is required.".

   LOGGING:
   - Logs only high-level actions for debugging.
   ========================================================== */
/* ========= Product option validator (global) =========
   Default: ALL visible [data-custom-option-input] are required.
   Opt-out per field with data-ps-optional="true".
   Optional custom message: data-ps-required-msg="..."
   ==================================================== */
(function () {
  const TAG = '[ps-options]';
  const DEBUG = true; // set true while debugging

  const log = (...args) => DEBUG && console.log(...args);

  document.addEventListener('click', onAddClick, true);
  document.addEventListener('submit', onFormSubmit, true);

  document.addEventListener('input', (e) => {
    if (e.target?.matches('[data-custom-option-input]')) clearError(e.target);
  });
  document.addEventListener('change', (e) => {
    if (e.target?.matches('[data-custom-option-input]')) clearError(e.target);
  });

  function onAddClick(e) {
    const btn = e.target.closest('button.product-form__cart-submit[name="add"]');
    if (!btn) return;
    const scope = getScope(btn);
    if (scopeHasSkip(scope)) return;
    log(`${TAG} add click`, { btn, scope });
    guard(e, scope);
  }

  function onFormSubmit(e) {
    const form = e.target.closest('form.product-form[data-product-form]');
    if (!form) return;
    const scope = getScope(form);
    if (scopeHasSkip(scope)) return;
    log(`${TAG} form submit`, { form, scope });
    guard(e, scope);
  }

  function guard(e, scope) {
    const { ok, firstBad } = validateScope(scope);
    if (!ok) {
      log(`${TAG} BLOCKING add`);
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation?.();
      focusBad(firstBad);
    } else {
      log(`${TAG} allowing add`);
    }
  }

  function getScope(el) {
    return el.closest('[id^="shopify-section-"]') || document;
  }
  function scopeHasSkip(scope) {
    return !!scope.closest('[data-ps-skip-validation="true"]');
  }

  function validateScope(scope) {
    const all = Array.from(scope.querySelectorAll('[data-custom-option-input]'))
      .filter(isVisible)
      .filter((el) => el.getAttribute('data-ps-optional') !== 'true');

    log(`${TAG} inputs considered (required by default):`, all.length, all);
    if (!all.length) return { ok: true, firstBad: null };

    let firstBad = null;

    all.forEach((el, idx) => {
      clearError(el);
      const type = (el.type || '').toLowerCase();
      const val = (type === 'checkbox' || type === 'radio')
        ? (el.checked ? '[checked]' : '')
        : (el.value || '').trim();

      let fieldOK = isFilled(el);
      if (fieldOK && type === 'email' && !isEmail(val)) {
        fieldOK = false;
        showError(el, 'Enter a valid email address.');
      } else if (fieldOK && type === 'date' && !inDateRange(el, val)) {
        fieldOK = false;
        showError(el, el.getAttribute('data-ps-range-msg') || 'Please pick a date in the allowed range.');
      } else if (!fieldOK) {
        showError(el, getRequiredMessage(el));
      }

      log(`${TAG} check`, {
        name: el.getAttribute('aria-label') || el.name || el.id || `index ${idx}`,
        type, value: val, fieldOK
      });

      if (!fieldOK && !firstBad) firstBad = el;
    });

    log(`${TAG} validate result`, { ok: !firstBad, firstBad });
    return { ok: !firstBad, firstBad };
  }

  // helpers
  function isVisible(el) {
    if (el.disabled) return false;
    const s = getComputedStyle(el);
    if (s.display === 'none' || s.visibility === 'hidden' || s.opacity === '0') return false;
    return !!(el.offsetParent || el.getClientRects().length);
  }
  function isFilled(el) {
    const t = (el.type || '').toLowerCase();
    if (t === 'checkbox') return el.checked;
    if (t === 'radio') {
      const group = document.querySelectorAll(
        `[data-custom-option-input][name="${CSS.escape(el.name)}"]`
      );
      return Array.from(group).some((r) => r.checked);
    }
    return (el.value || '').trim() !== '';
  }
  function isEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); }
  // A typed date can pass the picker's own min and max, so check them here. YYYY-MM-DD strings
  // compare correctly as text. Gift class emails can be held 30 days at most (Phil, 2026-09-21).
  function inDateRange(el, v) {
    if (el.min && v < el.min) return false;
    if (el.max && v > el.max) return false;
    return true;
  }
  function getRequiredMessage(el) {
    return el.getAttribute('data-ps-required-msg') || 'This field is required.';
  }
  function showError(el, msg) {
    const wrap =
      el.closest('.product__controls-group') ||
      el.closest('.product__custom-option') ||
      el.parentElement || el;
    wrap.querySelector('.ps-error')?.remove();
    el.classList.add('ps-bad');
    const note = document.createElement('div');
    note.className = 'ps-error';
    note.textContent = msg;
    wrap.appendChild(note);
  }
  function clearError(el) {
    el.classList.remove('ps-bad');
    const wrap =
      el.closest('.product__controls-group') ||
      el.closest('.product__custom-option') ||
      el.parentElement;
    wrap?.querySelector('.ps-error')?.remove();
  }
  function focusBad(el) {
    try {
      el?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      el?.focus?.({ preventScroll: true });
    } catch (_) {}
  }
})();
